export default __webpack_public_path__ + "static/media/card-3.c921973b.webp";